import { MoonStar, SunMedium } from 'lucide-react';

import { useTheme } from '@/hooks/use-theme';
import { cn } from '@/lib/utils';

interface ThemeToggleProps {
  className?: string;
}

export function ThemeToggle({ className }: ThemeToggleProps) {
  const { isDark, toggleTheme } = useTheme();
  const label = isDark ? 'Chuyển sang giao diện sáng' : 'Chuyển sang giao diện tối';

  return (
    <button
      type="button"
      onClick={toggleTheme}
      aria-label={label}
      title={label}
      className={cn(
        'inline-flex items-center justify-center gap-2 rounded-full border border-slate-200 bg-white px-3 py-2 text-sm font-semibold text-slate-600 shadow-[0_10px_25px_-5px_rgba(148,163,184,0.15)] transition hover:border-cyan-200 hover:text-slate-900 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-cyan-200 dark:border-slate-700 dark:bg-slate-900 dark:text-slate-100 dark:hover:border-cyan-400 dark:hover:text-white',
        className,
      )}
    >
      {isDark ? <MoonStar className="h-4 w-4 text-cyan-400" /> : <SunMedium className="h-4 w-4 text-cyan-500" />}
      <span className="hidden sm:inline">{isDark ? 'Dark' : 'Light'}</span>
      <span className="sr-only">{label}</span>
    </button>
  );
}
